//libs
import React, { memo } from 'react';

//components
import ViewSimilar from 'shared/components/ViewSimilar/ViewSimilar';

//styles
import { Container, Text } from './styles';

// hooks
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

interface ViewSimilar {
  className?: string;
  onClick: (event: MouseEvent) => void;
}

const ViewSimilarIcon = ({ className = '', onClick }: ViewSimilar) => {
  const VIEW_SIMILAR_TEXT = 'View Similar';
  const isViewSimilarEnabled = useRemoteConfig('viewSimilarPLP').desktop;

  if (!isViewSimilarEnabled) return null;
  return (
    <Container className={className} onClick={onClick} data-at="viewsimilar-icon">
      <ViewSimilar />
      <Text className="vs-text">{VIEW_SIMILAR_TEXT}</Text>
    </Container>
  );
};

export default memo(ViewSimilarIcon);
